// Lógica pura de ordenação/filtro da central de notificações, extraída de
// index.jsx para poder ser testada sem montar o componente (que depende de
// firebase/auth e de services de rede).

export const MODAL_FILTERS = {
  todas: "visible",
  nao_lidas: "unread",
  uteis: "liked",
  ocultas: "hidden",
};

export const EMPTY_MESSAGES = {
  todas: "Nenhuma notificação por aqui ainda.",
  nao_lidas: "Tudo lido por aqui 🎉",
  uteis: "Você ainda não marcou nenhuma notificação como útil.",
  ocultas: "Você não ocultou nenhuma notificação.",
};

// Mesma ordem da API (data e, no empate, id), para o "Carregar mais"
// continuar de onde parou.
export function sortNotifications(notifications) {
  return [...(notifications || [])].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime() ||
      b.id - a.id,
  );
}

export function splitByVisibility(notifications) {
  const sorted = sortNotifications(notifications);
  return {
    visible: sorted.filter((n) => !n.is_hidden),
    hidden: sorted.filter((n) => n.is_hidden),
  };
}

// Aplica o filtro do modal ("todas" | "nao_lidas" | "uteis" | "ocultas")
// sobre as listas já separadas por visibilidade.
export function filterNotifications(notifications, modalFiltro) {
  const { visible, hidden } = splitByVisibility(notifications);
  const base = modalFiltro === "ocultas" ? hidden : visible;
  return base.filter((n) => {
    if (modalFiltro === "nao_lidas") return !n.is_read;
    if (modalFiltro === "uteis") return n.reaction === "like";
    return true;
  });
}

export function hasMoreToLoad(filtradas, notificationCounts, modalFiltro) {
  const total = notificationCounts?.[MODAL_FILTERS[modalFiltro]] ?? 0;
  return filtradas.length < total;
}
